import ModelDetail from './ModelDetail';
import { connect } from './connect';

export default connect(ModelDetail);
